<p>mail-manager works!</p>
